import { render, staticRenderFns } from "./PermisoOrdenServicioView.vue?vue&type=template&id=6d132035"
import script from "./PermisoOrdenServicioView.vue?vue&type=script&lang=js"
export * from "./PermisoOrdenServicioView.vue?vue&type=script&lang=js"
import style0 from "./PermisoOrdenServicioView.vue?vue&type=style&index=0&id=6d132035&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports